import {
    CardActionsPostActions,
    CardBoxed,
    CardContentPost,
    CardHeaderPostHeader,
    TypographyCardContent,
    TypographyHeaderSubTitle,
} from "./Post.styles";
import * as React from "react";
import { Skeleton } from "@mui/material";
import { StyledToggleButtonSkeleton } from "./PostActions/PostActionButtons.styles";

export default function SkeletonPost({
    isBoxed = true,
    isPostDetails = false,
}) {
    return (
        <CardBoxed isBoxed={isBoxed}>
            {!isPostDetails && (
                <CardHeaderPostHeader
                    avatar={
                        <Skeleton
                            animation="wave"
                            variant="circular"
                            width={40}
                            height={40}
                        />
                    }
                    title={
                        <TypographyHeaderSubTitle>
                            <Skeleton animation="wave" width="128px" />
                        </TypographyHeaderSubTitle>
                    }
                    subheader={
                        <TypographyHeaderSubTitle>
                            <Skeleton animation="wave" width="64px" />
                        </TypographyHeaderSubTitle>
                    }
                />
            )}
            <CardContentPost>
                <TypographyCardContent>
                    <Skeleton animation="wave" variant="text" width="90%" />
                    <Skeleton animation="wave" variant="text" width="95%" />
                    <Skeleton animation="wave" variant="text" width="50%" />
                </TypographyCardContent>
            </CardContentPost>

            <CardActionsPostActions>
                <StyledToggleButtonSkeleton variant="rounded" />
                <StyledToggleButtonSkeleton variant="rounded" />
                <StyledToggleButtonSkeleton variant="rounded" />
            </CardActionsPostActions>
        </CardBoxed>
    );
}
